import React, { Component } from 'react';
import HoverButton from "../buttons/HoverButton";
import loginAPI from "../api/loginAPI";
import PopUp from "../base/popup";

class ResendActivationEmail extends Component {

    successPopup = React.createRef();
    state = {
        user: this.props.user,
    };

    handleSubmit = (e) => {
        let user = this.props.user;
        e.preventDefault();
        let _this = this;
        loginAPI.resendAccountInstructions({id: this.props.educator_id}).then( (response) => {
            this.successPopup.current.open();
        }).catch(error => {
            console.log(error);
        });
    };

    render () {
        return (
            <React.Fragment>
                {this.props.type == 'link' ? <span onClick={this.handleSubmit} className="payment__desc green-link">request again here</span> :
                    <HoverButton onClick={this.handleSubmit}>
                        Resend Activation Email
                    </HoverButton>
                }
                <PopUp ref={this.successPopup}>
                    <div className="grid-x align-center">
                        <div className="small-12 cell text-center">
                                <h3 className="mar-bot-10">Email sent!</h3>
                                <p className="popup__text">An email with account activation instructions was sent to your email {this.props.educator_email}.</p>
                        </div>
                    </div>
                </PopUp>
            </React.Fragment>);
    }

}
export default ResendActivationEmail;